import { render, staticRenderFns } from "./vcToolbarCrud.vue?vue&type=template&id=060473ad&"
import script from "./vcToolbarCrud.vue?vue&type=script&lang=js&"
export * from "./vcToolbarCrud.vue?vue&type=script&lang=js&"
import style0 from "./vcToolbarCrud.vue?vue&type=style&index=0&id=060473ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports